import { setCookie } from '../helpers/cookie';

export default function adBanner() {
  const adBannerEl = document.querySelector('.ad-banner');

  if (adBannerEl) {
    document.body.classList.add('is-banner-visible');
    const adBannerCloseBtn = adBannerEl.querySelector('#banner-close-btn');

    adBannerCloseBtn.addEventListener('click', () => {
      adBannerEl.remove();
      document.body.classList.remove('is-banner-visible');
      setCookie('isLegalIntakeGuideBannerClosed', true, 365);
    });
  }
}
